"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const Fieldset = styled_components_1.default.fieldset((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.fieldset-title': {
        fontSize: [1, 2],
        color: 'secondary',
        ml: [3, '10px'],
        mb: [2, 1],
    },
}));
const RadioGroupInput = props => {
    const { testId = 'radioGroup', value, options = [], onChange, title, className, name, renderCustomOption, } = props;
    return (react_1.default.createElement(Fieldset, { className: className || '' },
        title && react_1.default.createElement("legend", { className: "fieldset-title" }, title),
        react_1.default.createElement("div", { className: "radio-group-container" }, options.map((option, i) => {
            var _a;
            const radioInputTestId = `${testId}_${option.value}`;
            const finalProps = Object.assign(Object.assign({}, option), { name,
                onChange, testId: radioInputTestId, checked: value === option.value });
            const key = (_a = option.value) !== null && _a !== void 0 ? _a : i;
            if (renderCustomOption)
                return (react_1.default.createElement(react_1.default.Fragment, { key: key }, renderCustomOption(finalProps)));
            return react_1.default.createElement(components_common_buttons_1.RadioButton, Object.assign({ key: key }, finalProps));
        }))));
};
exports.default = RadioGroupInput;
//# sourceMappingURL=RadioGroup.js.map